import React, { Component } from "react";
import {
  Table,
  Button,
  FormGroup,
} from "reactstrap";
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import Moment from "react-moment";
import 'react-block-ui/style.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import DisplayRecordText from "../../controls/_DisplayRecordText"
import Pagination from 'react-js-pagination';
import EditUser from './_EditUser';
import AddUser from './_AddUser';
import { storedb } from '../../../views/client/storedb'

import * as adminActions from './actions';
import AdminUserTypes from './constants'

var dbContext;

class AdminUser extends Component {
  constructor(props) {
    super(props);

    dbContext = storedb();
    this.state = {
      modalEdit: false,
      modalAdd: false,
      list: [],
      keyword: '',
      total_record: 0,
      page: 1,
      per_page: 20,
    };
  }

  fetchList = (page) => {
    const { adminUserListRequest } = this.props

    var requestData = {
      keyword: this.state.keyword,
      page: page || this.state.page,
      per_page: this.state.per_page
    }

    return adminUserListRequest(requestData)
  }

  loadUsers = () => {
    var requestData = {
      loadAll: true,
      storeId: dbContext.getStoreId()
    }

    return this.props.loadUsers(requestData)
  }
  loadLuongCoBan = () => {
    var requestData = {
      store: dbContext.getStoreId()
    }
    return this.props.loadLuongCoBan(requestData)
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.adminUserList.type === AdminUserTypes.LIST_SUCCESS) {
      let list = nextProps.adminUserList.listData.records;
      let total_record =  nextProps.adminUserList.listData.total_record;
      let per_page =  nextProps.adminUserList.listData.per_page;
      this.setState({ list ,total_record, per_page});
    }
    if (nextProps.adminUserList.type === AdminUserTypes.ITEM_REMOVE_SUCCESS) {
      this.fetchList()
      this.loadUsers()
    }
  }

  handleSearchChange = (evt) => {
    this.setState({
      keyword: evt.target.value
    });
  }
  keyPress = (e) => {
    if(e.keyCode == 13){
       this.search()
    }
  }
  toggleAdd = () => {
    if (!this.state.modalAdd) {
      let requestForm = {
        storeId: dbContext.getStoreId()
      }
      this.props.adminUserItemRequest(requestForm);

      this.setState(() => ({
        modalAdd: true,
      }));
    }
    else {
      //close 
      this.setState(() => ({
        modalAdd: false,
      }));
      this.props.adminUserResetData();
    }
  }

  toggleEdit = (obj) => {
    if (!this.state.modalEdit) {
      let requestForm = {
        username: obj.username,
      }
      this.props.adminUserItemRequest(requestForm);
      this.setState(() => ({
        modalEdit: true,
      }));
    }
    else {
      //close 
      this.setState(() => ({
        item: {},
        modalEdit: false,
      }));

      this.props.adminUserResetData();
    }
  }

  processRemoveItem = (item) => {
    const requestForm = {
      username: item.username,
    }
    this.props.adminUserRemoveItemRequest(requestForm);
  }
  handleRoleChange = (values) => {
    this.props.adminUserSetDataForItem("permissions", values);
  }
  removeItem = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn có muốn xóa nhân viên <b className="text-danger">{item.TenDayDu}</b> này không?<br />
              Việc này đồng nghĩa nhân viên này không thể sử dụng được phần mềm nữa.
            </p>
            <button className="text-danger" onClick={() => {
              this.processRemoveItem(item);
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }

  search = () => {
    if (this.props.adminUserList.listRequesting) {
      return false;
    }
    this.setState({ page: 1 }, () => this.fetchList(1));
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  getListPermissions = (permission_records) => {
    permission_records = permission_records || [];
    return permission_records.map((item) => {
      return { value: item.Id, label: item.Name, name: item.Description };
    });
  }
  componentDidMount() {
    this.fetchList()
    this.loadUsers()
    this.loadLuongCoBan()
  }

  render() {
    const { list } = this.state
    const {
      handleSubmit,
      adminUserList: {
        listRequesting,
        requesting,
        messages,
        errors,
        item,
      },
    } = this.props
    // Lọc lấy danh sách users để đưa vào dropdownlist chọn quản lý 
    // cần loại bỏ chính nó để không có trường hợp chính nó quản lý nó
    const getListUsers = (users, excludeUser) => {
      if (!users) return []
      return users.filter(item => {
        return item.Id != excludeUser.Id
      })
    }
    const buildSelectOption = (bacluong) => {
      var options = [];
      if (bacluong && bacluong.length > 0) {
        bacluong.map((item) => { options.push({ Id: item.Id, Name: item.Ten }) }
        );
      }
      return options;
    }
    const userSelection = () => {
      if (!item.user) return []
      const quanLyId = item.user['QuanLyId']
      return [quanLyId]
    }
    const userLuongSelection = () => {
      if (!item.user) return []
      const bacLuongId = item.user['BacLuongId']
      return [bacLuongId]
    }

    const permissionList = this.getListPermissions(item.permission_records); 
    const permissions = item.permissions;
    const dataUser = item.user || {};
    const startIndex = (this.state.page - 1) * this.state.per_page
    
    return (
      <div className="animated fadeIn">
        <div className="row col-sm-12 pl-0 pr-0">
          <div className="col-sm-6 mb-1 pull-left">
            <FormGroup>
              <Field type="text" name="keyword" placeholder="Tài khoản, Tên, điện thoại, địa chỉ" 
                className={"form-control"} 
                onChange={e => this.handleSearchChange(e)} 
                onKeyDown={e => this.keyPress(e)}
                component="input" />
            </FormGroup>
          </div>
          <div className="col-sm-6 mb-1 pull-left">
            <div className="btn-group" role="group">
              <Button className="btn btn-success mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i>&nbsp;Tìm kiếm</Button>
              <Button className="btn btn-secondary" onClick={e => this.toggleAdd(e)}><i className="fa fa-plus"></i>&nbsp;Thêm nhân viên</Button>
            </div>
          </div>
        </div>
        <BlockUi tag="div" blocking={listRequesting}>
          <div className="mt-2 bg-white">
            <div className="col-sm-12 pr-0 pl-0">

              <div className="w-100">
                <DisplayRecordText
                  itemsCountPerPage={this.state.per_page}
                  onChangeItem={this.onChangeItem}
                />

                <Table hover responsive className="table-outline table-sm mb-0 d-sm-table table table-hover">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" width="50">#</th>
                      <th scope="col" width="120">Tài khoản</th>
                      <th scope="col">Tên</th>
                      <th scope="col" width="120" className="text-center">Đ/nhập cuối</th>
                      <th scope="col" width="100" className="text-center">Điện thoại</th>
                      <th scope="col" className="text-center">Quản lý</th>
                      <th scope="col" width="100" className="text-center">S/lần Đ/Nhập</th>
                      <th scope="col" width="80" className="text-center">Trạng thái</th>
                      {/* <th scope="col" width="50" className="text-center">Xoá</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {list && !!list.length && (
                      list.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td>{startIndex + (idx + 1)}</td>
                          <td> <button className="btn btn-link pl-0" onClick={e => this.toggleEdit(res)}>{res.username}</button> </td>
                          <td>
                            <button className="btn btn-link pl-0" onClick={e => this.toggleEdit(res)}>{res.ten_day_du}</button>
                          </td>
                          <td className="text-center">
                            {res.login_at && <Moment format="HH:mm DD/MM/YYYY" tz="UTC">{`${res.login_at}`}</Moment>}
                          </td>
                          <td className="text-center">{res.dien_thoai}</td>
                          <td className="text-center">{res.ten_quan_ly}</td>
                          <td className="text-center">{res.login_count}</td>
                          <td className="text-center">
                          {res.is_active == 1 && (
                            <i className="fa fa-check fa-3 text-success"></i>
                          )}
                          {res.is_active == 0 && (
                            <i className="fa fa-close fa-3 text-danger"></i>
                          )}
                          </td>
                          {/* <td className="text-center">
                            <Button className="btn-sm" color="danger" onClick={e => this.removeItem(res)}><i className="fa fa-trash-o"></i></Button>
                          </td> */}
                        </tr>
                      ))
                    )}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="9">
                        <span className="text-success mr-2"><i className="fa fa-check"></i> = Đang hoạt động</span>
                        <span className="text-danger"><i className="fa fa-close"></i> = Dừng hoạt động</span>
                      </td>
                    </tr>
                  </tfoot>
                </Table>
                {this.state.total_record > this.state.per_page && (
                  <nav>
                    <Pagination
                      activePage={this.state.page}
                      itemsCountPerPage={this.state.per_page}
                      totalItemsCount={this.state.total_record}
                      pageRangeDisplayed={5}
                      onChange={this.handlePageChange}
                    />
                  </nav>
                )}
                {/* Modal */}
                <EditUser
                  adminUserSetDataForItem={this.props.adminUserSetDataForItem}
                  adminUserSetDataForUser={this.props.adminUserSetDataForUser}
                  resetError={this.props.resetError}
                  adminUserSetErrors={this.props.adminUserSetErrors}
                  parentProps={this.props}
                  handleSubmit={handleSubmit}
                  requesting={requesting}
                  messages={messages}
                  errors={errors}
                  data={dataUser}
                  item={item}
                  permissionList={permissionList}
                  permissions={permissions}
                  isEditing={this.state.modalEdit}
                  userSelection={userSelection()}
                  userLuongSelection={userLuongSelection()}
                  listUsers={getListUsers(this.props.adminUserList.listUsers, dataUser)}
                  listLuong={buildSelectOption(this.props.adminUserList.listLuong)}
                  updateUser={this.props.adminUserItemUpdateRequest}
                  fetchList={() => {
                    this.fetchList();
                    this.loadUsers();
                  }}
                  onClose={this.toggleEdit}
                  resetDataItem={this.props.resetDataItem} 
                  handleRoleChange={this.handleRoleChange}/>
                <AddUser
                 adminUserSetDataForItem={this.props.adminUserSetDataForItem}
                  adminUserSetDataForUser={this.props.adminUserSetDataForUser}
                  resetError={this.props.resetError}
                  adminUserSetErrors={this.props.adminUserSetErrors}
                  parentProps={this.props}
                  handleSubmit={handleSubmit}
                  requesting={requesting}
                  messages={messages}
                  errors={errors}
                  data={dataUser}
                  item={item}
                  isAdding={this.state.modalAdd}
                  permissionList={permissionList}
                  permissions={permissions}
                  userSelection={userSelection()}
                  userLuongSelection={userLuongSelection()}
                  listUsers={getListUsers(this.props.adminUserList.listUsers, dataUser)}
                  listLuong={buildSelectOption(this.props.adminUserList.listLuong)}
                  addUser={this.props.adminUserItemAddRequest}
                  fetchList={() => {
                    this.fetchList();
                    this.loadUsers();
                  }}
                  onClose={this.toggleAdd}
                  handleRoleChange={this.handleRoleChange}/>
                {/* End Modal */}

              </div>
            </div>
          </div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  adminUserList: state.adminUserList,
  client: state.client,
})

const connected = connect(mapStateToProps,
  {
    adminUserSetDataForItem: adminActions.adminUserSetDataForItem,
    adminUserListRequest: adminActions.adminUserListRequest,
    adminUserItemRequest: adminActions.adminUserItemRequest,
    adminUserItemAddRequest: adminActions.adminUserItemAddRequest,
    adminUserItemUpdateRequest: adminActions.adminUserItemUpdateRequest,
    adminUserSetError: adminActions.adminUserSetError,
    adminUserSetErrors: adminActions.adminUserSetErrors,
    adminUserSetDataForUser: adminActions.adminUserSetDataForUser,
    adminUserRemoveItemRequest: adminActions.adminUserRemoveItemRequest,
    adminUserResetData: adminActions.adminUserResetData,
    loadUsers: adminActions.loadUsers,
    loadLuongCoBan: adminActions.loadLuongCoBan,
    resetError: adminActions.resetError,

  })(AdminUser)

const formed = reduxForm({
  form: 'adminUserList',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Admin/AdminUser/AdminUser.js